var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.669024 0C0.536559 2.84655e-05 0.407115 0.0323812 0.297239 0.0929219C0.187364 0.153463 0.10205 0.239441 0.0522051 0.339864C0.00235976 0.440287 -0.00975197 0.550592 0.0174183 0.656677C0.0445886 0.762762 0.109806 0.859806 0.204733 0.935403L6.39267 5.99871L0.204733 11.062C0.140827 11.1122 0.0898053 11.1724 0.0546569 11.2389C0.0195085 11.3054 0.000939759 11.3771 3.8293e-05 11.4495C-0.000863173 11.522 0.0159209 11.5939 0.0494071 11.6611C0.0828933 11.7282 0.132409 11.7891 0.195054 11.8404C0.257698 11.8917 0.332213 11.9322 0.414234 11.9596C0.496254 11.987 0.584132 12.0007 0.67272 12C0.761309 11.9992 0.848826 11.984 0.930148 11.9553C1.01147 11.9265 1.08496 11.8848 1.14632 11.8325L7.80505 6.38394C7.92988 6.28176 8 6.14319 8 5.99871C8 5.85423 7.92988 5.71567 7.80505 5.61348L1.14632 0.164946C1.08427 0.112752 1.01006 0.0712642 0.92808 0.0429335C0.846101 0.0146029 0.758014 4.25925e-06 0.669024 0Z",
    fill: "#BABEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPage);
export default __webpack_public_path__ + "static/media/next-page.847aae401d9ec68d87b4267a82a6ed21.svg";
export { ForwardRef as ReactComponent };